import { Injectable } from '@angular/core';
import { ModuleInstanceTemplate } from '../cms-models';

@Injectable()
export abstract class IContainerService {
  abstract getModuleInstanceTemplates();
  abstract saveModuleInstanceTemplate(template: ModuleInstanceTemplate);
}